import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from "ngx-uploader";

import { UploadDirectory } from './enumeration';

import { DomSanitizer } from '@angular/platform-browser';
import { EventEmitter } from "@angular/core";
import { ConnectedUserComponent } from "../shared/connectedUserComponent";


// import { TOKEN_NAME } from "../../services/auth.constant";

export class UploadComponent extends ConnectedUserComponent{

    imageToShow: any;
    formData: FormData = { concurrency: 1, autoUpload: false, verbose: true };
    files: UploadFile[] = [];
    uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
    humanizeBytes: Function;
    dragOver: boolean;
    componentObject: any;
    UploadDirectory = UploadDirectory;
    isGallery: Boolean = null;
    isUpdate: Boolean = null;

    constructor(protected sanitizer?: DomSanitizer) {
        super();
        this.imageToShow = null;
        this.isGallery = false;
    }

    onUploadOutput(output: UploadOutput): void {
        if (output.type === 'allAddedToQueue') {
            this.allAddedToQueue();
        } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
            this.addedToQueue(output);
        } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
            const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
            this.files[index] = output.file;
            this.onUploadProgress(output.file);
        } else if (output.type === 'done') {
            //this.removeFile(output.file.id);
            /*this.files.forEach(file => {
                this.onUploadComplete(file);
            });*/
            this.onUploadComplete(output.file);
            
            this.onUploadProgress(null);
            
        } else if (output.type === 'removed') {
            this.files = this.files.filter((file: UploadFile) => file !== output.file);
        } else if (output.type === 'dragOver') {
            this.dragOver = true;
        } else if (output.type === 'dragOut') {
            this.dragOver = false;
        } else if (output.type === 'drop') {
            this.dragOver = false;
        } 
    }

    onUploadProgress(file: UploadFile){
        
    }

    allAddedToQueue() {
        if ((this.isUpdate !== null && this.isUpdate &&
            (this.componentObject.dataUpload.typeFile == UploadDirectory.LOGO))) {
            const event: UploadInput = {
                type: 'uploadAll',
                url: "/api/upload/upload-file",
                method: 'POST',
                data: this.componentObject.dataUpload,
                // concurrency: this.formData.concurrency,
                //  headers : {'Authorization':'Bearer '+localStorage.getItem(TOKEN_NAME)}
            };
            this.uploadInput.emit(event);
        }
        else if (this.componentObject.dataUpload.typeFile == UploadDirectory.COTATION_DOCS) {
            const event: UploadInput = {
                type: 'uploadAll',
                url: "/api/upload/upload-file",
                method: 'POST',
                data: this.componentObject.dataUpload,
                // concurrency: this.formData.concurrency,
                // headers : {'Authorization':'Bearer '+localStorage.getItem(TOKEN_NAME)}
            };
            this.uploadInput.emit(event);

        }
        else if (this.componentObject.dataUpload.typeFile == UploadDirectory.BULK_IMPORT) {
            const event: UploadInput = {
                type: 'uploadAll',
                url: "/api/upload/upload-file-import",
                method: 'POST',
                data: this.componentObject.dataUpload,
                // concurrency: this.formData.concurrency,
                // headers : {'Authorization':'Bearer '+localStorage.getItem(TOKEN_NAME)}
            };
            this.uploadInput.emit(event);

        }
        else if (this.componentObject.dataUpload.typeFile == UploadDirectory.INVOICE) {
            const event: UploadInput = {
                type: 'uploadAll',
                url: "/api/upload/upload-file-invoice",
                method: 'POST',
                data: this.componentObject.dataUpload,
                // concurrency: this.formData.concurrency,
                //  headers : {'Authorization':'Bearer '+localStorage.getItem(TOKEN_NAME)}
            };
            this.uploadInput.emit(event);

        }
        else {
        }
    }

    addedToQueue(output: UploadOutput) {
        this.files.push(output.file);
        if (this.isGallery !== null && !this.isGallery &&
            (this.componentObject.dataUpload.typeFile == UploadDirectory.LOGO)) {
            this.createImageFromBlob(output.file.nativeFile);
        }

        else if (this.componentObject.dataUpload.typeFile == UploadDirectory.COTATION_DOCS) {
        }
    }

    startUpload(): void {
        const event: UploadInput = {
            type: 'uploadAll',
            url: "/api/upload/upload-file",
            method: 'POST',
            data: this.componentObject.dataUpload,
            // concurrency: this.formData.concurrency,
            // headers : {'Authorization':'Bearer '+localStorage.getItem(TOKEN_NAME)}
        };
        
        this.uploadInput.emit(event);
    }

    cancelUpload(id: string): void {
        this.uploadInput.emit({ type: 'cancel', id: id });
    }

    removeFile(id: string): void {
        this.uploadInput.emit({ type: 'remove', id: id });
    }

    removeAllFiles(): void {
        this.uploadInput.emit({ type: 'removeAll' });
    }

    createImageFromBlob(image: any) {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
            this.imageToShow = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);

        }, false);

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    onUploadComplete(file: UploadFile){
    }

    // getImage() {
    //     this.componentObject.imageService.getImage(this.urlImage).subscribe(data => {
    //         this.createImageFromBlob(data);
    //     });
    // }
}

interface FormData {
    concurrency: number;
    autoUpload: boolean;
    verbose: boolean;
}



// WEBPACK FOOTER //
// ./src/app/utils/uploadComponent.ts